<p-card class="dashBoard dashBoard-arr">
  <div class="title" [routerLink]="['/reports/auto-rebalance-report']">Automated Rebalances</div>
  <ng-container [ngTemplateOutlet]="currentStatusPanel"></ng-container>
  <div class="clear"></div>
  @if (!autoRebalancePortfolioData || !autoRebalanceOrderData) {
    <div class='loading-spinner'></div>
  }
  @if (autoRebalancePortfolioData && autoRebalanceOrderData) {
    <div class="auto-reb-content-wrapper pane">
      <!--        <div class="auto-reb-content-child auto-reb-null-state" *ngIf="nullstate">-->
      <!--            <div class="block bold">There are no Automated Rebalances configured.</div>-->
      <!--            <div class="block">You can configure a Portfolio to rebalance automatically by selecting it on the Portfolios page.</div>-->
      <!--            <div class="block"><button class="btn-medium-secondary" (click)="goToPortfolios()">Go to Portfolios page</button></div>-->
    <!--        </div>-->
    <div class="">
      <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight [(selectedIndex)]="selectedIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            {{autoRebalancePortfolioData.totalAutoRebalPfCount
            + ((currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0)
            ? autoRebalancePortfolioData.totalScheduledAutoRebalPfCount: 0)}} Portfolios
            @if (selectedIndex != 0) {
              <span>
                @if (autoRebalancePortfolioData.totalAutoRebalPfCount > 0 && autoRebalancePortfolioData.autoRebalErrorCount > 0) {
                  <span class="error-icon auto-reb-icon-spacer"></span>
                }
                @if (autoRebalancePortfolioData.totalAutoRebalPfCount > 0 && autoRebalancePortfolioData.autoRebalErrorCount == 0) {
                  <span class="success-circle-icon auto-reb-icon-spacer"></span>
                }
                @if (autoRebalancePortfolioData.totalAutoRebalPfCount === 0
                  && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0) {
                  <fa-icon [icon]="faClock" class="irb-blue auto-reb-icon-spacer" style="font-size: 1.125em;"></fa-icon>
                }
              </span>
            }
          </ng-template>
          <ng-template matTabContent>
            <div class="bordered-block">
              <div class="auto-reb-panel-header"><b>Today</b>&nbsp;&nbsp;&nbsp;{{currentDate}}</div>
              @if ((!autoRebalancePortfolioData.totalAutoRebalPfCount
                && (!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount || currentDate !== nextDate || nullstate))) {
                <div class="auto-reb-panel-message">
                  <div class="center">There are no Automated Rebalances scheduled for today.</div>
                </div>
              }
              @if (autoRebalancePortfolioData.totalAutoRebalPfCount > 0 ||
                currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0) {
                @if (autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0 && currentDate === nextDate) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPfScheduled()">
                    <table>
                      <tr>
                        <td class="column-icon"><fa-icon [icon]="faClock" class="irb-blue" style="padding-left: 2px; font-size: 1.125em;"></fa-icon></td>
                        <td class="column-count">{{autoRebalancePortfolioData.totalScheduledAutoRebalPfCount | number}}</td>
                        <td class="column-label">Portfolios to be rebalanced</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (autoRebalancePortfolioData.autoRebalErrorCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPfErrors()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="error-icon"></span></td>
                        <td class="column-count">{{autoRebalancePortfolioData.autoRebalErrorCount | number}}</td>
                        <td class="column-label">Rebalance errors</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (autoRebalancePortfolioData.autoRebalPfOrdersCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPfOrders()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="success-circle-icon"></span></td>
                        <td class="column-count">{{autoRebalancePortfolioData.autoRebalPfOrdersCount | number}}</td>
                        <td class="column-label">Rebalanced portfolios with orders</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (autoRebalancePortfolioData.autoRebalPfNoOrdersCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPfNoOrders()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="success-circle-icon"></span></td>
                        <td class="column-count">{{autoRebalancePortfolioData.autoRebalPfNoOrdersCount | number}}</td>
                        <td class="column-label">Rebalanced portfolios without orders</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
              }
            </div>
            @if (currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount >0 || currentDate !== nextDate) {
              <div class="bordered-block">
                <div class="auto-reb-panel-header"><b>Upcoming</b>&nbsp;&nbsp;&nbsp;{{nextDate || ''}}</div>
                @if ((autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0) && currentDate !== nextDate && !nullstate) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPfScheduled()">
                    <table>
                      <tr>
                        <td class="column-icon"><fa-icon [icon]="faClock" class="irb-blue" style="padding-left: 2px; font-size: 1.125em;"></fa-icon></td>
                        <td class="column-count">{{autoRebalancePortfolioData.totalScheduledAutoRebalPfCount | number}}</td>
                        <td class="column-label">Portfolios to be rebalanced</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount >0) {
                  <div class="auto-reb-panel-message">
                    <div class="center">Upcoming automated rebalances are being processed. Please try again later.</div>
                  </div>
                }
                @if (!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount && nextDate && currentDate !== nextDate) {
                  <div class="auto-reb-panel-message">
                    <div class="center">There are no automated rebalances scheduled for {{nextDate}}</div>
                  </div>
                }
                @if ((!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount && !nextDate) || nullstate) {
                  <div class="auto-reb-panel-message">
                    <div class="center">There are no automated rebalances scheduled. You can configure them from&nbsp;<a (click)="goToPortfolios();">Portfolios</a></div>
                  </div>
                }
              </div>
            }
            <div class="clear"></div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            {{autoRebalanceOrderData.totalCount}} Orders
            @if (selectedIndex != 1) {
              <span>
                @if (autoRebalanceOrderData.approvedCount > 0) {
                  <fa-icon [icon]="faClock" class="irb-blue auto-reb-icon-spacer" style="font-size: 1.125em;"></fa-icon>
                }
                @if (autoRebalanceOrderData.approvedCount == 0 && autoRebalanceOrderData.errorCount > 0) {
                  <span class="error-icon auto-reb-icon-spacer"></span>
                }
                @if (autoRebalanceOrderData.approvedCount == 0 && autoRebalanceOrderData.errorCount == 0) {
                  <span class="success-circle-icon auto-reb-icon-spacer"></span>
                }
              </span>
            }
          </ng-template>
          <ng-template matTabContent>
            <div class="bordered-block">
              <div class="auto-reb-panel-header"><b>Today</b>&nbsp;&nbsp;&nbsp;{{currentDate}}</div>
              @if ((!autoRebalanceOrderData.totalCount && currentDate !== nextDate) || nullstate) {
                <div class="auto-reb-panel-message">
                  <div class="center">There are no Automated Rebalances scheduled for today.</div>
                </div>
              }
              @if (!autoRebalanceOrderData.totalCount && currentDate === nextDate) {
                <div class="auto-reb-panel-message">
                  <div class="center">Automated rebalance orders are being processed. Please try again later.</div>
                </div>
              }
              @if (autoRebalanceOrderData.totalCount > 0) {
                @if (autoRebalanceOrderData.approvedCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalPending()">
                    <table>
                      <tr>
                        <td class="column-icon"><fa-icon [icon]="faClock" class="irb-blue" style="padding-left: 2px; font-size: 1.125em;"></fa-icon></td>
                        <td class="column-count">{{autoRebalanceOrderData.approvedCount | number}}</td>
                        <td class="column-label">Pending orders</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (autoRebalanceOrderData.errorCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebalError()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="error-icon"></span></td>
                        <td class="column-count">{{autoRebalanceOrderData.errorCount | number}}</td>
                        <td class="column-label">Order errors</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (autoRebalanceOrderData.submitedCount > 0) {
                  <div class="auto-reb-panel-button" (click)="showAutoRebal()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="success-circle-icon"></span></td>
                        <td class="column-count">{{autoRebalanceOrderData.submitedCount | number}}</td>
                        <td class="column-label">Submitted orders</td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
              }
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<div class="widget-footer">
  <div class="timestamp">{{timestamp}}</div>
  <a class="" (click)="refreshWidgetData()">
    <div class="refreshIcon"></div>
    Refresh
  </a>
</div>
</p-card>

<ng-template #currentStatusPanel>
  <div class="bordered-block current-status right">
    @if (!globalSettings?.isAutoRebalanceEnabled) {
      <div class="right"><span class="bold">Trading</span>&nbsp;&nbsp;<a (click)="showGlobalSettingsDialog();"><span class="play-icon"></span>Disabled</a></div>
    }
    @if (globalSettings?.isAutoRebalanceEnabled && globalSettings?.isTradingPaused) {
      <div class="right"><span class="bold">Trading</span>&nbsp;&nbsp;<a (click)="showGlobalSettingsDialog();"><span class="pause-icon"></span>Paused</a></div>
    }
    @if (globalSettings?.isAutoRebalanceEnabled  && !globalSettings?.isTradingPaused) {
      <div class="right"><span class="bold">Order time</span>&nbsp;&nbsp;<a (click)="showGlobalSettingsDialog();"><span class="play-icon"></span>{{globalSettings?.tradeTime}}</a></div>
    }

  </div>
  <div class="clear"></div>
</ng-template>

